goog.provide('el8.ext.onboarding.identityForm');

goog.require('el8.ext.Form');
goog.require('el8.template.ext.onboarding.identityForm');
goog.require('el8.service.urls');
goog.require('el8.ext.onboarding.signupData');
goog.require('el8.ext.util');
goog.require('el8.util.consts');
goog.require('el8.ext.onboarding.ButtonSet');
goog.require('el8.ext.onboarding.notDoctorDialog');
goog.require('el8.ext.onboarding.noProfileDialog');


el8.ext.onboarding.identityForm.init = function(spec) {

    var formGuide = spec.formGuide;
    var formName = spec.name;

    var displayMode = 'search';  // or 'profile' or 'manual'

    var $container = spec.container.find('.form-guide-container');
    $container.html(el8.template.ext.onboarding.identityForm.content());

    var $searchArea = $('.onboarding-profile-search', $container);
    var $manualProfile = $('.onboarding-manual-profile', $container);
    var $profileDisplay = $('.onboarding-profile-display', $container);
    var $form = $('form', $container);

    var manualProfileFields = [
        'firstName', 'middleName', 'lastName', 'suffix', 'credential',
        'address', 'suite', 'city', 'state', 'zip',
        'phone', 'fax', 'npi', 'licenseNumber', 'licenseState'
    ];

    var validationOpts = el8.ext.util.validationOpts();
    validationOpts['errorPlacement'] = function(error, element) {
        var name = $(element).attr('name');
        if (name === 'state' || name === 'zip' ||
                name === 'licenseState' || name === 'licenseNumber') {
            var $existing = $('.error-msg[data-name="'+name+'"]', $container)
                .addClass('el8AlertText');
            $existing.text($(error).text());

        // as normal
        } else {
            $(error).attr('data-name', name);
            var $existing = $(element).prev('.error-msg');
            if ($existing.length) {
                $existing.replaceWith($(error));
            } else {
                $(error).insertBefore($(element));
            }
        }
    };
    validationOpts['unhighlight'] = function(element, errorClass) {

        el8.ext.util.unhighlightError($(element));

        var name = $(element).attr('name');
        if (name === 'state' || name === 'zip' ||
                name === 'licenseState' || name === 'licenseNumber') {
            $('.error-msg[data-name="'+name+'"]', $container).empty();
        // as normal
        } else {
            $(element).prevAll('.error-msg').empty();
        }
    };

    var _GAtrackSearch = _.once(function() {
        _gaq.push(['_trackPageview', el8Globals['OB']+'page-identity/search/']);
    });

    var that = new el8.ext.Form({
        container: $form,
        name: formName,
        buttonElt: spec.container.find('.form-guide-buttons'),
        buttonSetConstructor: el8.ext.onboarding.ButtonSet,
        validationOpts: validationOpts,
        firstFieldSelector: ':input[name="firstName"]',
        fields: [
            {
                name: 'profileSearch',
                selector: ':input[name="profileSearch"]',
                infoText: 'Start typing your name...',
                size: 'xl',
                maxLength: 200,
                newMindreader: true,
                mindreaderOpts: {
                    url: el8.service.urls.get('profileLookup'),
                    formatResult: function(item) {
                        _GAtrackSearch();
                        return el8.template.ext.onboarding.identityForm.profileResult({item: item});
                    },
                    formatSelected: function(item) {
                        return item.first_name + ' ' + item.last_name;
                    },
                    selectFn: function(e, item) {
                        _gaq.push(['_trackPageview', el8Globals['OB']+'page-identity/selected-self/']);
                        el8.ext.onboarding.signupData.setProfileId(item.id);
                        el8.ext.onboarding.signupData.setFullName(
                            el8.template.ext.onboarding.identityForm.profileFullName({item: item})
                        );
                        olark && olark('api.visitor.updateFullName', {fullName: el8.ext.onboarding.signupData.getFullName()});
                        that._waitProfileDisplay();
                        that._validateProfile(item,
                            function() {
                                that._showProfileDisplay(item);
                            },
                            function() {
                                that._showProfileDisplay(item, true);
                            }
                        );
                    },
                    actions: [
                        {
                            name: 'Don\'t see your profile? Manually sign up here',
                            actionFn: function() {
                                that._showProfileDisplay(null);
                                _gaq.push(['_trackPageview', el8Globals['OB']+'page-identity/cant-find-self/']);
                            }
                        }
                    ]
                }
            },
            {
                name: 'credential',
                selector: ':input[name="credential"]'
            },
            {
                name: 'firstName',
                selector: ':input[name="firstName"]',
                infoText: 'First Name...',
                size: 'large',
                maxLength: 35,
                validate: {
                    required: true
                },
                validateMsgs: {
                    required: 'Required Field'
                }
            },
            {
                name: 'middleName',
                selector: ':input[name="middleName"]',
                infoText: 'Middle Name (optional)...',
                size: 'large',
                maxLength: 35
            },
            {
                name: 'lastName',
                selector: ':input[name="lastName"]',
                infoText: 'Last Name...',
                size: 'large',
                maxLength: 35,
                validate: {
                    required: true
                },
                validateMsgs: {
                    required: 'Required Field'
                }
            },
            {
                name: 'suffix',
                selector: ':input[name="suffix"]',
                infoText: 'Suffix (optional)...',
                size: 'large',
                maxLength: 10
            },
            {
                name: 'address',
                selector: ':input[name="address"]',
                infoText: 'Practice Address...',
                size: 'large',
                maxLength: 35,
                validate: {
                    required: true
                },
                validateMsgs: {
                    required: 'Required Field'
                }
            },
            {
                name: 'suite',
                selector: ':input[name="suite"]',
                infoText: 'Suite or Apartment No. (optional)...',
                size: 'large',
                maxLength: 10
            },
            {
                name: 'city',
                selector: ':input[name="city"]',
                infoText: 'City...',
                size: 'large',
                maxLength: 35,
                validate: {
                    required: true
                },
                validateMsgs: {
                    required: 'Required Field'
                }
            },
            {
                name: 'state',
                selector: ':input[name="state"]',
                infoText: 'State...',
                maxLength: 2,
                size: 'large',
                validate: {
                    state: true,
                    required: true
                },
                validateMsgs: {
                    state: 'Not a valid US state',
                    required: 'Required Field'
                }
            },
            {
                name: 'zip',
                selector: ':input[name="zip"]',
                infoText: 'Zip Code...',
                maxLength: 10,
                size: 'large',
                validate: {
                    zip: true,
                    required: true
                },
                validateMsgs: {
                    required: 'Required Field'
                }
            },
            {
                name: 'phone',
                selector: ':input[name="phone"]',
                infoText: 'e.g. 555-555-5555...',
                size: 'large',
                maxLength: 15,
                validate: {
                    phone: true,
                    required: true
                },
                validateMsgs: {
                    phone: 'Not a valid US phone number',
                    required: 'Required Field'
                }
            },
            {
                name: 'fax',
                selector: ':input[name="fax"]',
                infoText: 'e.g. 555-555-5555 (optional)...',
                size: 'large',
                maxLength: 15,
                validate: {
                    phone: true
                },
                validateMsgs: {
                    phone: 'Not a valid US phone number'
                }
            },
            {
                name: 'npi',
                selector: ':input[name="npi"]',
                maxLength: 10,
                size: 'large',
                infoText: '10-digit NPI...',
                validate: {
                    exactlength: 10,
                    digits: true,
                    required: true,
                    remote: {
                        url: el8.service.urls.get('validNpi'),
                        type: 'GET'
                    }
                },
                validateMsgs: {
                    exactlength: 'Must be exactly 10 digits',
                    digits: 'Can only contain digits',
                    required: 'Required Field',
                    remote: 'NPI Already Taken'
                }
            },
            {
                name: 'licenseState',
                selector: ':input[name="licenseState"]',
                size: 'large',
                infoText: 'State...',
                maxLength: 2,
                validate: {
                    state: true,
                    required: true
                },
                validateMsgs: {
                    required: 'Required Field'
                }
            },
            {
                name: 'licenseNumber',
                size: 'large',
                maxLength: 35,
                infoText: 'License Number...',
                selector: ':input[name="licenseNumber"]',
                validate: {
                    required: true
                },
                validateMsgs: {
                    required: 'Required Field'
                }
            }
        ]
    });

    var super_init = that._init;
    that._init = function() {

        super_init.call(that);

        $container.on('click', '.wrong-profile-trigger',  function() {
            that._hideProfileDisplay();
            that.focusField('profileSearch');
        }).on('click', '.not-doctor-trigger',  function() {
            _gaq.push(['_trackPageview', el8Globals['OB']+'page-identity/not-doctor/']);
            el8.ext.onboarding.notDoctorDialog.show();

        }).on('blur', ':input[name="state"]',  function() {
            if (!$(this).hasClass('has-error')) {
                that.setVal('licenseState', that.getVal('state'));
            }

        });
    };

    var super_render = that.render;
    that.render = function(fresh) {
        super_render.call(that);
        if (fresh) {
            that._hideProfileDisplay();
        } else {
            if (displayMode === 'search') {
                that.focusField('profileSearch');
            } else {
                that.populate(el8.ext.onboarding.signupData.asMap());
                if (!el8.ext.onboarding.signupData.getConfirmCredential()) {
                    $(that._getConfirmCredentialElt()[0]).prop('checked', true);
                }
            }
        }
        _gaq.push(['_trackPageview', el8Globals['OB']+'page-identity/show/']);
    };

    /**
     * Validate inputs
     */
    var super_isValid = that.isValid;
    that.isValid = function() { // over-ride
        return (displayMode !== 'manual') ? !$('.has-error', $container).length :
            (super_isValid.call(that) && !$('.has-error', $container).length);
    };
    that._validateProfile = function(profile, validCb, invalidCb) {
        $.el8_ajax({
            type: 'GET',
            url: el8.service.urls.get('validNpi'),
            data: {'npi': profile.npi},
            success: function(data) {
                if (data) {
                    validCb(profile);
                } else {
                    invalidCb(profile);
                }
            },
            error: function() {
                formGuide.showErrorPage();
            }
        });
    };

    /**
     * Helper methods
     */
    that._addNextButton = function() {
        that.addButton('next', 'Continue to Step 2 of 3', function(_form, $btn) {
            if (that.isValid()) {
                $btn.prop('disabled', true);
                var mapped = {};
                if (displayMode !== 'manual') {
                    mapped['profile_id'] = el8.ext.onboarding.signupData.getProfileId();
                    var confirmCredential = that._getConfirmCredentialElt(true).val();
                    mapped['confirm_credential'] = confirmCredential;
                    el8.ext.onboarding.signupData.setConfirmCredential(confirmCredential);
                } else {
                    var manualProfile = that.getMappedFields(manualProfileFields);
                    mapped['manual_profile'] = manualProfile;
                    el8.ext.onboarding.signupData.populate(manualProfile);
                    console.debug(el8.ext.onboarding.signupData);
                    el8.ext.onboarding.signupData.setFullName(
                        that.getVal('firstName') +
                        (that.getVal('middleName') ? ' '+that.getVal('middleName') : '') +
                        ' '+that.getVal('lastName') +
                        (that.getVal('suffix') ? ' '+that.getVal('suffix') : '')
                    );
                    olark && olark('api.visitor.updateFullName', {fullName: el8.ext.onboarding.signupData.getFullName()});
                }
                $.el8_ajax({
                    type: 'POST',
                    async: false, // need to have an ID
                    data: {data: JSON.stringify(mapped)},
                    url: el8.service.urls.get('signup', [el8.ext.onboarding.signupData.getId()]),
                    success: function(data) {
                        formGuide.next(formName);
                        if (data['signup_id']) {
                            el8.ext.onboarding.signupData.setId(data['signup_id']);
                        }
                        $btn.prop('disabled', false);
                    },
                    error: function() {
                        formGuide.showErrorPage();
                    }
                });
            }
        }, true);
        that.renderButtonSet();
    };

    that._removeNextButton = function() {
        that.removeButton('next');
        that.renderButtonSet();
    };

    that._waitProfileDisplay = function() {
        $searchArea.hide();
        $profileDisplay.show().addClass('el8OBLoading')
            .html(el8.template.ext.onboarding.identityForm.verifying());
    };

    that._showProfileDisplay = function(item, isTaken) {

        displayMode = 'profile';
        $searchArea.hide();
        $profileDisplay.removeClass('el8OBLoading');

        if (item) {
            $profileDisplay.html(
                el8.template.ext.onboarding.identityForm.profileDisplay({
                    item: item,
                    isTaken: isTaken
                })
            ).show();
            that._hideManualProfile();
            if (!isTaken) {
                $(that._getConfirmCredentialElt()[0]).prop('checked', true).focusFocus();
            }
        } else {
            $profileDisplay.empty().hide();
            that._showManualProfile();
        }

        if (!isTaken) {
            that._addNextButton();
        }
        if (!item) { that.focusField('firstName'); }
    };

    that._hideProfileDisplay = function() {

        displayMode = 'search';
        $profileDisplay.empty().hide();
        that._hideManualProfile();

        $searchArea.show();

        that._removeNextButton();
        that.focusField('profileSearch');
    };

    that._showManualProfile = function() {

        displayMode = 'manual';
        $manualProfile.show();

        // Make sure to default select MD
        that.setVal('credential', 'MD');

        // TODO Do we like this?
        var nameSearched = that.getVal('profileSearch');
        if (nameSearched) {
            var names = nameSearched.split(' ');
            that.setVal('firstName', names[0].capitalize());
            if (names.length > 2) {
                that.setVal('middleName', names[1].capitalize());
                that.setVal('lastName', names.slice(2, names.length).join(' ').capitalize());
            } else if (names.length > 1) {
                that.setVal('lastName', names.slice(1, names.length).join(' ').capitalize());
            }
        }

        that.focusField('firstName');
    };

    that._hideManualProfile = function() {
        $manualProfile.hide();
        if (that._validator) { that._validator.resetForm(); }
        manualProfileFields.map(function(fieldName) {
            that.resetInfoField(fieldName);
        });
    };

    that._getConfirmCredentialElt = function(isChecked) {
        if (isChecked) {
            return $('input:radio[name="confirmCredential"]:checked', $container);
        } else {
            return $('input:radio[name="confirmCredential"]', $container);
        }
    };

    return that;

};
